import { LEAGUE_TABLES } from '../../data/leagueTable';
import type { TeamOption } from './types';

export const APP_VERSION = 'v2.4.0 (118)';
export const HELP_URL = 'https://headtohead.dk/support';
export const TERMS_URL = 'https://headtohead.dk/terms';
export const FEEDBACK_EMAIL = 'support@headtohead.dk';

/** Last-resort team list, used only if no live competition standings have been
 *  ingested yet (keeps the favourite-team picker from being empty offline). */
export const FALLBACK_TEAM_OPTIONS: TeamOption[] = (() => {
  const seen = new Map<string, TeamOption>();
  for (const table of Object.values(LEAGUE_TABLES)) {
    for (const row of table?.rows ?? []) {
      if (!seen.has(row.code)) seen.set(row.code, { name: row.name, code: row.code });
    }
  }
  return [...seen.values()].sort((a, b) => a.name.localeCompare(b.name));
})();
